import React, { Component } from 'react'

class LabSetup extends Component {
    render(){
        return(
            <div className=' my-profile-container'>
                 <h4 className='w3-center w3-container'><b>LAB Setup At IIT Roorkee</b></h4>
                 <div className='w3-container'>
                 <table className="w3-table-all w3-margin-bottom "   >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='1'>State of Art Facilities Developed</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Hybrid Microgrid Test System(AC and DC subgrid) with Capability of Operating in Islanded and Grid Connected Mode System</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Flexible in Using as AC Microgrid.</td>
                                
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Flexible in Using as DC Microgrid.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Concept Verification Lab for any proposed Algorithm.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Effect of Transient Analysis in different Microgrid Architecture.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Different types of load(AC as well as DC Load) testing.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Two setup: (a) Non-Programmable (b) Programmable </td>
                               
                            </tr>

                            
                            </tbody>
                        </table> 
                        </div>

                    

                        <div className='w3-row'>
                        <div className="w3-half w3-container w3-margin-bottom">
                            <div className="w3-card-2 w3-white w3-round-large w3-center">
                                <header className="w3-container w3-light-grey ">
                                <h6><b>NON-PROGRAMMABLE SETUP</b></h6>
                                </header>
                                <div className="w3-row">
                                <img className='my-stage' src='./images/lab_non_programmable.png' alt='lab_non_programmable'/>
                                </div>            
                            </div>
                        </div>
                        <div className="w3-container w3-margin-bottom w3-half">
                        <table className="w3-table-all "  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='1'>Non-Programmable Setup Specifications</th> 
                            </tr>
                            </thead>
                            <tbody>
                           
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Operating Capability in Hybrid Microgrid and AC Microgrid Architecture</td>
                                
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Effect of Transient Analysis in Hybrid Microgrid and AC Microgrid Microgrid Architecture.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Different types of load(AC as well as DC Load) testing.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Mode Selection Option: a) SBG, b) SGB, c) GSB, d) GFM and e) INV</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>SBG Level Options : 25%, 50%, 75% & 100%.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>SBG/GFM Buffer Level Options : 25%, 50%, 75% & 100%.</td>
                               
                            </tr>

                            
                            </tbody>
                        </table>
                        </div> 
                        </div>


                        <div className='w3-row'>
                        <div className="w3-half w3-container w3-margin-bottom">
                            <div className="w3-card-2 w3-white w3-round-large w3-center">
                                <header className="w3-container w3-light-grey ">
                                <h6><b>PROGRAMMABLE SETUP</b></h6>
                                </header>
                                <div className="w3-row">
                                <img className='my-stage' src='./images/lab_programmable.png' alt='lab_programmable'/>
                                </div>            
                            </div>
                        </div>
                        <div className='w3-margin-bottom w3-half w3-container'>
                        <table className="w3-table-all "  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='1'>Programmable Setup Specifications(Under Development)</th> 
                            </tr>
                            </thead>
                            <tbody>
                           
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Flexible in Using as AC Microgrid.</td>
                                
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Flexible in Using as DC Microgrid.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Flexible in Using as Hybrid Microgrid.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Concept Verification Lab for any proposed Algorithm.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Effect of Transient Analysis in different Microgrid Architecture.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Different types of load(AC as well as DC Load) testing.</td>
                               
                            </tr>
                           
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Controllable with any controller PWM having logic level: 3.3V or 5V Logic</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Interlock: Enable and Disable Option </td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Level shifting option: Enable and Disable</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Adjustable Levelshift upto 5 Volt</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Adjustable Gain in sensors</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Adjustable Orvercurrent Trip Level</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Trip latch functionality with rest option</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Controller based ON/OFF/Tripping option</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Option of Operating in different DC voltage level upto 400V DC</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Any Converter can by used alone in isolation with other converters.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Different controls can be tested like: V/F, STATCOM, AC & DC Motor Drive control etc are possible.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>System level and Individual Trip Point Option are available .</td>
                               
                            </tr>

                            </tbody>
                        </table> 
                        </div>
                        </div>
                      
            </div>
        )
    }
}

export default LabSetup